import { render, staticRenderFns } from "./supportKnowledge.vue?vue&type=template&id=405909f0&scoped=true&"
import script from "./supportKnowledge.vue?vue&type=script&lang=js&"
export * from "./supportKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405909f0",
  null
  
)

export default component.exports